import http from '../http';
import request from '../http/request';
// 获取城市
export function getCityListApi(params) {
  return request('/riskcontrol/vehicle/citylist', { method: 'GET', params });
}
// export const getCityListApi = (params, config = {}) => http.get('/riskcontrol/vehicle/cityList', { params, ...config });
// 车辆列表
export function getList(params) {
  return request('/riskcontrol/vehicle/vehicleList', { method: 'GET', params });
}
// 地图定位信息列表
export function getLocationList(params) {
  return http.get('/riskcontrol/vehicle/locationList', { params });
}
// 车辆定位信息
export function getLocation(params) {
  return request('/riskcontrol/vehicle/location', { method: 'GET', params });
}
// 车辆定位信息
export function getFence(params) {
  return http.get('/riskcontrol/vehicle/electricFence', { params });
}
// 获取分组列表
export function getGroupList(params) {
  return request('/riskcontrol/vehicle/group/list', { method: 'GET', params });
}
// 获取某个车辆分组列表
export function getVehicleGroup(params) {
  return request('/riskcontrol/vehicle/groups', { method: 'GET', params });
}
// 移动分组
export function moveGroup(params) {
  return request('/riskcontrol/vehicle/moveGroup', { method: 'POST', params });
}
// 新增分组
export function addGroup(params) {
  return request('/riskcontrol/vehicle/group', { method: 'POST', params });
}
// 移出分组
export function moveCurrentGroup(params) {
  return request('/riskcontrol/vehicle/deleteGroup', { method: 'POST', params });
}
// 编辑分组
export function updateGroup(params) {
  return request('/riskcontrol/vehicle/group', { method: 'PUT', params });
}
// 删除分组
export function delGroupApi(params) {
  return request(`/vehicle/group?id=${params.id}`, { method: 'DELETE', params });
}
// 获取自定义列
export function getColumnList(params) {
  return request('/riskcontrol/vehicle/column/list', { method: 'GET', params });
}
// 设置自定义列
export function setColumnList(params) {
  return request('/riskcontrol/vehicle/column', { method: 'POST', params });
}
// 车辆备注信息编辑
export function setRemark(params) {
  return request('/riskcontrol/vehicle/remark', { method: 'POST', params });
}
// 车辆历史轨迹
export function getTrajectory(params) {
  return request('/riskcontrol/vehicle/trajectoryV2', { method: 'GET', params });
}
